module.exports = __webpack_public_path__ + "static/media/book1.35b247b4.jpg";